import { SearchOutlined } from '@ant-design/icons';
import { Button, Card, DatePicker, Descriptions, Empty, Form, Input, Space, Tag, Typography, notification } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useState } from 'react';
import { ReplayGameNameLookup } from '../api/go';
import type { ReplayGameNameLookupResult } from '../api/go';

type LookupForm = {
  game_name: string;
  month: Dayjs;
};

function getErrorMessage(err: any) {
  if (err?.status) {
    return `请求失败: ${err.status}`;
  }
  if (err?.message) {
    return err.message;
  }
  return '请求失败';
}

function sourceTag(source: string) {
  if (source === 'gowar_replay_cheating_report') {
    return <Tag color="purple">gowar_replay_cheating_report</Tag>;
  }
  if (source === 'sky_match_info') {
    return <Tag color="blue">sky_match_info</Tag>;
  }
  return <Tag>{source || '-'}</Tag>;
}

export default function ReplayGameNameLookupPage() {
  const [form] = Form.useForm<LookupForm>();
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [result, setResult] = useState<ReplayGameNameLookupResult | null>(null);

  async function queryGameName(values: LookupForm) {
    const gameName = values.game_name.trim();
    setLoading(true);
    setSearched(true);
    setResult(null);
    try {
      const data = await ReplayGameNameLookup.query({
        game_name: gameName,
        month: values.month.format('YYYY-MM'),
      });
      setResult(data);
    } catch (err) {
      notification.error({ message: getErrorMessage(err) });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ textAlign: 'left' }}>
      <Card title="GameName 转 GameId">
        <Form<LookupForm>
          form={form}
          layout="vertical"
          onFinish={queryGameName}
          initialValues={{ month: dayjs().startOf('month') }}
        >
          <Space align="end" wrap>
            <Form.Item<LookupForm>
              label="GameName"
              name="game_name"
              rules={[{ required: true, whitespace: true, message: '请输入 GameName' }]}
            >
              <Input autoFocus placeholder="请输入 GameName" disabled={loading} style={{ width: 360 }} />
            </Form.Item>
            <Form.Item<LookupForm> label="月份" name="month" rules={[{ required: true, message: '请选择月份' }]}>
              <DatePicker picker="month" format="YYYY-MM" allowClear={false} disabled={loading} style={{ width: 180 }} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                查询
              </Button>
            </Form.Item>
          </Space>
        </Form>

        {result ? (
          <Descriptions bordered size="small" column={1} style={{ marginTop: 8 }}>
            <Descriptions.Item label="GameId">
              <Typography.Text copyable={{ text: result.game_id }}>{result.game_id}</Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="GameName">
              <Typography.Text copyable={{ text: result.game_name }}>{result.game_name}</Typography.Text>
            </Descriptions.Item>
            <Descriptions.Item label="来源">{sourceTag(result.source)}</Descriptions.Item>
            <Descriptions.Item label="开始时间">
              {result.start_time || <Typography.Text type="secondary">-</Typography.Text>}
            </Descriptions.Item>
          </Descriptions>
        ) : searched && !loading ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="未查询到 GameId" />
        ) : null}
      </Card>
    </div>
  );
}
